<template>
  <v-bottom-navigation class="teal darken-2" dark app>
    <v-btn to="/" @click="vibrationHelper">
      <span>首頁</span>
      <v-icon>
        mdi-home
      </v-icon>
    </v-btn>

    <v-btn to="/forecast" @click="vibrationHelper">
      <span>天氣亂報</span>
      <v-icon>
        mdi-file-question
      </v-icon>
    </v-btn>

    <v-btn to="/about" @click="vibrationHelper">
      <span>關於</span>
      <v-icon>
        mdi-cloud-question
      </v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
export default {

}
</script>

<style lang="scss">

</style>
